import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b2a63702&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b2a63702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a63702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2a63702')) {
      api.createRecord('b2a63702', component.options)
    } else {
      api.reload('b2a63702', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b2a63702&scoped=true&", function () {
      api.rerender('b2a63702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/CargoAgGridDimensionEditor/index.vue"
export default component.exports